<template>
    <div class="top">
        <div class="left">
            <img src="../images/login/tongzhi.png" alt="" />
            <span>{{ mer_broadcast }}</span>
        </div>
        <div class="right">
            <span @click="to('/applyProcess')">报名流程</span>
        </div>
    </div>
</template>
<script>
import { system2 } from "@/api/all";
export default {
    data() {
        return {
            mer_broadcast: "",
            fullPath: "",
        };
    },
    created() {
        this.getSystem();
    },
    watch: {
        $route() {
            this.fullPath = this.$route.fullPath;
            this.getSystem();
        },
    },
    methods: {
        getSystem() {
            system2().then((res) => {
                this.mer_broadcast = res.data.system.mer_broadcast;
            });
        },
        to(url) {
            let back_s = localStorage.getItem("back_s");
            if (this.fullPath != url) {
                this.$router.push({
                    path: "/"+back_s+url,
                });
            }
        },
    },
};
</script>
<style scoped lang="less">
.top {
    width: 1200px;
    display: flex;
    padding: 20px 30px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 10px;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    .left {
        display: flex;
        align-items: center;
        img {
            margin-right: 10px;
        }
    }
    .right {
        width: 124px;
        height: 40px;
        background: #e14d29;
        border-radius: 10px 10px 10px 10px;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        color: #fff;
        span {
            cursor: pointer;
        }
    }
}
</style>